import request from "@/utils/request";
import qs from 'qs'
/*
*订舱管理暂存
*/
export function publicSave(data) {
  return request({
    url: '/web/orderEdit/publicSave',
    method: 'post',
    data
  });

}/*
*订舱管理暂存
*/
export function saveEbParty(data) {
  return request({
    url: '/web/orderEdit/saveEbParty',
    method: 'post',
    data
  });
}

/*
*订舱管理直接提交
*/
export function saveAndSub(data) {
  return request({
    url: '/web/orderEdit/saveAndSub',
    method: 'post',
    data
  });
}

/*
*订舱管理提交
*/
export function publicSubmit(data) {
  return request({
    url: '/web/orderEdit/publicSubmit',
    method: 'post',
    data
  });
}

export function publicBill(data) {
  return request({
    url: '/web/orderEdit/publicBill',
    method: 'post',
    data
  });
}

export function changeIsActive(data) {
  return request({
    url: '/web/orderEdit/changeIsActive',
    method: 'post',
    data
  });
}

/**订舱管理批量提交**/
export function batchSubmitBooking(data) {
  return request({
    url: '/web/booking/batchSubmitBooking',
    method: 'post',
    data
  });
}

/**订舱管理退关**/
export function batchCancel(data) {
  return request({
    url: '/web/booking/batchCancel',
    method: 'post',
    data
  });
}

/**订舱管理撤销修改**/
export function batchUpdateOrderStatus(data) {
  return request({
    url: '/web/booking/batchUpdateOrderStatus',
    method: 'post',
    data
  });
}

// export function revokeSub(data) {
//   return request({
//     url: '/web/orderEdit/revokeSub',
//     method: 'post',
//     data
//   });
// }

/**获取订舱编辑数据**/
export function getBookingVO(data) {
  return request({
    url: '/web/booking/getBookingVO',
    method: 'post',
    data
  });
}

/**订单新增-暂存草稿**/
export function saveBookingDTO(data) {
  return request({
    url: '/web/booking/saveBookingDTO',
    method: 'post',
    data
  });
}

/**订单新增-提交**/
export function submitBookingDTO(data) {
  return request({
    url: '/web/booking/submitBookingDTO',
    method: 'post',
    data
  });
}

/**订单新增-暂存草稿与提交**/
// export function saveAndSub(data) {
//   return request({
//     url: '/web/orderEdit/saveAndSub?type=' + data.ebOrderDTO.type,
//     method: 'post',
//     data
//   });
// }

/**订单新增-存为模板**/
export function saveEbOrderTemplate(data) {
  return request({
    url: '/web/booking/saveEbOrderTemplate',
    method: 'post',
    data
  });
}

// 船公司扩展信息
export function getCarrierInfoStr(data) {
  return request({
    url: '/neHttp/mdCarrierInfoCustom/getCarrierInfoStr?carrierId=' + data.carrierId + '&businessType=' + data.type,
    method: 'post',
    data
  });
}

// 查询
/**订单新增-暂存草稿与提交**/
export function getOrderdata(data) {
  return request({
    url: '/web/orderEdit/getOrderdata',
    method: 'post',
    data
  });
}

/**批量提交**/
export function batchSubmit(data) {
  return request({
    url: '/web/orderEdit/batchSubmit',
    method: 'post',
    data
  });
}
//预货物信息删除
export function deleteEbCargo(data) {
  return request({
    url: '/web/orderEdit/deleteEbCargo',
    method: 'post',
    data
  });
}
//预配箱删除
export function deleteEbCtnRequest(data) {
  return request({
    url: '/web/orderEdit/deleteEbCtnRequest',
    method: 'post',
    data
  });
}
export function updateCtnMum(data) {
  return request({
    url: '/web/orderEdit/updateCtnMum',
    method: 'post',
    data
  });
}
//编辑页撤销
export function revokeSub(data) {
  return request({
    url: '/web/orderEdit/revokeSub',
    method: 'post',
    data
  });
}
//管理页批量撤销
export function batchRevokeSub(data) {
  return request({
    url: '/web/orderEdit/revokeSub',
    method: 'post',
    data
  });
}

export function getEbServiceItem (data) {
  return request({
    url: '/web/billEdit/getEbServiceItem',
    method: 'post',
    data
  })
}

export function checkForSubmit(data) {
  return request({
    url: '/web/manifest/checkForSubmit',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
